/**
 * KAN-947 — spread onto a small control so it gets the invisible 44 x 44 tap area from
 * `touchTapArea.css` (imported once from `src/index.js`):
 *
 *   const { isTouch } = useResponsiveLayout();
 *   <button {...touchTapAreaProps(isTouch)} …>
 *
 * Touch only: a mouse keeps the exact drawn box. The look never changes — only the area
 * a finger can land in grows. See the CSS file for the rules about neighbours.
 */
export const TOUCH_TAP_ATTRIBUTE = 'data-cvx-tap';
export const TOUCH_TAP_SIZE = 44;

const TAP_PROPS = Object.freeze({ [TOUCH_TAP_ATTRIBUTE]: String(TOUCH_TAP_SIZE) });
const NO_PROPS = Object.freeze({});

/** @param {boolean} [isTouch] @returns {{ 'data-cvx-tap'?: '44' }} */
export function touchTapAreaProps(isTouch) {
  return isTouch ? TAP_PROPS : NO_PROPS;
}

export default touchTapAreaProps;
